import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import Card from "~/components-shared/Card";
import analyticsSelectors from "~/store/analytics/selectors";
import styled, { useTheme } from "styled-components";
import { Chart } from "react-chartjs-2";
import { RadarController, RadialLinearScale, PointElement, Filler, LineElement, Chart as ChartJs, Legend, Tooltip } from "chart.js";
import { Alert } from "~/components-shared";
import workingStyleCharts from "~/charts/workingStyles";
import analyticsActionCreators from "~/store/analytics/actions";
const Diagram = styled.div`
  width: 100%;
`;
ChartJs.register(RadarController, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);
const WorkingStyleChartCard = _ref => {
  let {
    email,
    ...rest
  } = _ref;
  const theme = useTheme();
  const analytics = useSelector(analyticsSelectors.getWorkingStyleProfile);
  const status = useSelector(analyticsSelectors.getWorkingStyleProfileStatus);
  const error = useSelector(analyticsSelectors.getWorkingStyleProfileError);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(analyticsActionCreators.fetchWorkingStyleProfileStarted(email));
  }, [dispatch, email]);
  return /*#__PURE__*/React.createElement(Card, _extends({
    s: {
      p: 0
    },
    loading: status === StatusStateEnum.LOADING
  }, rest), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Diagram, null, /*#__PURE__*/React.createElement(Chart, _extends({
    width: "100%"
  }, workingStyleCharts.profile(theme, analytics)))));
};
export default WorkingStyleChartCard;